<template>
  <div class="templib-temp-use-root">
    <div class="title">
      <div class="backbtn" @click="backWin" v-if="!SideBarTemplate">&lt; 返回</div>
      <div class="closebtn" @click="closeWin"></div>
      <span class="tips">选择您要插入的场景页</span>
    </div>
    <div class="list" v-loading="isLoading">
      <el-checkbox class="chkall" v-model="isCheckAll" @change="checkAll">全选</el-checkbox>
      <section class="scene-list">
        <templateUseItem
          :class="['scene-item','_'+template.direction]"
          v-for="(item, idx) in scenes"
          :key="idx"
          :sceneUI="item"
          :videoBlob="videoBlob"
          @checkDisable="checkDisable"
        ></templateUseItem>
      </section>
    </div>
    <div class="foot">
      <el-button
        :disabled="disable"
        class="insert"
        type="primary"
        round
        @click.native="loadTemplate('insertAdd')"
      >插入所选场景页</el-button>
      <el-button :disabled="disable" class="cover" type="text" @click="coverDialog">覆盖当前项目插入场景页</el-button>
    </div>
    <!-- 确认弹窗 -->
    <transition>
      <div class="dialog-bg" v-if="dialogVisible" @click="dialogVisible = false">
        <div class="win" @click.stop="dialogVisible = true">
          <div class="close" @click.stop="dialogVisible = false"></div>
          <div class="text">覆盖当前项目，将会清空当前画布的所有页面和配音内容，清空操作不可恢复，是否确定覆盖？</div>
          <div class="bottom">
            <el-button type="primary" @click.native.stop="loadTemplate('coverAdd')" class="yes">确 定</el-button>
            <el-button @click.stop="dialogVisible = false" class="no">取 消</el-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import templateUseItem from "./templateUseItem";
//import {} from ''
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "MaterialPane_Size",
      "TOOL",
      "SelectScenes_Msg",
      "UserEquity", // 用户权益
      "UserMsg",
      "SideBarTemplate",
      "WorksName"
    ]),
    ...mapGetters({
      soundHandle: "addSoundtrack/getPlayHandle"
    })
  },
  components: { templateUseItem },
  data() {
    return {
      scenes: [],
      tempJson: {},
      coverConfirm: false,
      dialogVisible: false,
      isCheckAll: true,
      isLoading: false,
      disable: false,
      videoBlob: null,
    };
  },
  props: ["template"],
  methods: {
    checkDisable() {
      this.disable = !(this.scenes.filter((x) => x.selected).length > 0);
    },
    backWin() {
      this.$bus.$emit("templib-tempuse-isopen", {});
    },
    closeWin() {
      this.$bus.$emit("templib-tempuse-isopen", {});
      this.$store.commit("close_TemplateMaterialLibDialogMsg");
      if (this.SideBarTemplate) {
        this.$store.commit("close_sideBarTemplate");
      }
    },
    coverDialog() {
      this.dialogVisible = true;
    },
    checkAll() {
      this.scenes.forEach((s) => {
        s.selected = this.isCheckAll;
      });
      this.checkDisable();
    },
    setFreeTemplateSprites (scene) {
      scene.FT = 1;
      if (scene.background) {
        scene.background.FT = 1;
      }
      scene.sprites && scene.sprites.forEach(sprite => {
        sprite.FT = 1;
      });
    },
    coverAdd: async function (saveWorks) {
      if (!saveWorks) {
        this.$store.commit('add_WorksTemplateId', this.template.id);
        this.$bus.emit('topnav.saveWorks', {
          templateId: this.template.id,
          onCompleted: () => {
            this.coverAdd(true);
          }
        });
        return;
      }
      this.closeWin();
      this.$store.commit("open_LibUseTemplateLoading");

      this.$store.commit("save_TopnavMsg", {
        isShowSavingMask: true,
        savingMaskText: "正在覆盖场景页..."
      });
      console.time('coverAdd');
      this.$bus.emit("showScenesLoading", true);
      this.dialogVisible = false;
      this.closeWin();
      let totalTime = 0;
      let music = [];
      try {
        let adds = [];
        for(let i = 0; i < this.scenes.length; i++) {
          if(this.scenes[i].selected) {
            adds.push(this.scenes[i]);
            totalTime += this.scenes[i].scene.duration;
          }
        }
        if (adds.length == 0) return;
        if(adds.length === this.scenes.length) {
          if(this.tempJson.sound && this.tempJson.sound[0] && !this.tempJson.sound[0].isRecord) {
            let mj = this.tempJson.sound[0];
            let duration = await this.loadSound(this.tempJson.sound[0].url);
            let m = {
              FT: 1,
              id: mj.resourceId,
              title: mj.title,
              fileType: mj.fileType,
              url: mj.url,
              cut: [mj.startTime, mj.endTime],
              timeSlot: [0, totalTime]
            }
            if(duration > 0.3) {
              if(!mj.endTime) {
                m.cut = [0, duration];
              }
              m.timeSlot[1] = Math.min(m.cut[1]-m.cut[0], totalTime);
            }
            music.push(m)
          }
          if(this.tempJson.music && this.tempJson.music.data) {
            for(let i = 0; i < this.tempJson.music.data.length; i++) {
              let sound = this.tempJson.music.data[i];
              if(sound.type === 1) continue;
              let obj = {
                FT: 1,
                title: sound.title,
                id: sound.resourceId,
                fileType: sound.fileType,
                url: sound.url,
                timeSlot: [sound.timeSlot[0], Math.min(sound.timeSlot[1], totalTime)],
                cut: [...sound.cut],
                startEffect: sound.startEffect,
                endEffect: sound.endEffect
              }
              music.push(obj);
            }
          }
        }
        let scale = this.TOOL.clientWidth / this.tempJson.resolution.width;
        let rmIds = this.TOOL.sprites.map((x) => x.id);
        let task = [];
        this.$bus.emit("loadingAllScenes", "start");
        for (let i = 0; i < rmIds.length; i++) {
          task.push(this.TOOL.removeScenes(rmIds[i]));
        }
        await Promise.all(task);
        for (let i = 0; i < adds.length; i++) {
          let newscene = await this.TOOL.addScenes();
          await this.TOOL.selectScenes(newscene);
          await newscene.toFromJson(adds[i].scene, scale);
          this.setFreeTemplateSprites(newscene);
          this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
        }
        this.$store.dispatch("resources/setRecent", {
          type: "template",
          id: this.template.id,
        });
        this.$bus.emit('undo_redo_clear');
      } catch (error) {
        console.error(error)
      } finally {
        this.$bus.emit("loadingAllScenes", "end");
        this.trackUseTemplate();
        this.$store.commit("close_LibUseTemplateLoading");
        this.soundHandle.coverScenesArrSound(totalTime, music);

        this.$bus.emit("showScenesLoading", false);
        this.$store.commit("save_TopnavMsg", {
          isShowSavingMask: false,
          savingMaskText: "正在覆盖场景页..."
        });
        console.timeEnd('coverAdd');
        return {end: true};
      }
    },
    insertAdd: async function (saveWorks) {
      if (!saveWorks) {
        this.$store.commit('add_WorksTemplateId', this.template.id);
        this.$bus.emit('topnav.saveWorks', {
          templateId: this.template.id,
          onCompleted: () => {
            this.insertAdd(true);
          }
        });
        return;
      }
      this.closeWin();
      this.$store.commit("open_LibUseTemplateLoading");
      console.time('insertAdd');
      let changeTime = [0, 0];
      let music = [];
      for(let i = 0; i < this.TOOL.sprites.length; i++) {
        changeTime[0] += this.TOOL.sprites[i].duration / 1000;
        if(this.TOOL.sprites[i].id === this.SelectScenes_Msg.id) {
          changeTime[1] = changeTime[0];
          break;
        }
      }
      this.$store.commit("save_TopnavMsg", {
        isShowSavingMask: true,
        savingMaskText: "正在插入场景页..."
      });
      this.$bus.emit("showScenesLoading", true);
      try {
        let adds = [];
        for(let i = 0; i < this.scenes.length; i++) {
          if(this.scenes[i].selected) {
            adds.push(this.scenes[i]);
            changeTime[1] += this.scenes[i].scene.duration;
          }
        }
        if (adds.length == 0) return;
        if(adds.length === this.scenes.length) {
          if(this.tempJson.sound && this.tempJson.sound[0] && !this.tempJson.sound[0].isRecord) {
            let mj = this.tempJson.sound[0];
            let duration = await this.loadSound(this.tempJson.sound[0].url);
            let m = {
              FT: 1,
              id: mj.resourceId,
              title: mj.title,
              fileType: mj.fileType,
              url: mj.url,
              cut: [mj.startTime, mj.endTime],
              timeSlot: [changeTime[0], changeTime[1]]
            }
            if(duration > 0.3) {
              if(!mj.endTime) {
                m.cut = [0, duration];
              }
              m.timeSlot[1] = m.timeSlot[0] + Math.min(m.cut[1]-m.cut[0], changeTime[1]-changeTime[0]);
            }
            music.push(m)
          }
          if(this.tempJson.music && this.tempJson.music.data) {
            for(let i = 0; i < this.tempJson.music.data.length; i++) {
              let sound = this.tempJson.music.data[i];
              if(sound.type === 1) continue;
              let obj = {
                FT: 1,
                title: sound.title,
                id: sound.resourceId,
                fileType: sound.fileType,
                url: sound.url,
                timeSlot: [sound.timeSlot[0]+changeTime[0], Math.min(sound.timeSlot[1]+changeTime[0], changeTime[1])],
                cut: [...sound.cut],
                startEffect: sound.startEffect,
                endEffect: sound.endEffect
              }
              music.push(obj);
            }
          }
        }
        let scale = this.TOOL.clientWidth / this.tempJson.resolution.width;
        let sceneIndex = this.SelectScenes_Msg.index + 1;
        this.$bus.emit("loadingAllScenes", "start");
        for (let i = adds.length - 1; i >= 0; i--) {
          let scene = await this.TOOL.addScenes();
          this.TOOL.moveScenesTo(scene.id, sceneIndex);
          await this.TOOL.selectScenes(scene);
          await scene.toFromJson(adds[i].scene, scale);
          this.setFreeTemplateSprites(scene);
          this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
        }
        this.$store.dispatch("resources/setRecent", {
          type: "template",
          id: this.template.id,
        });
      } catch (error) {
        console.error(error)
      } finally {
        this.$bus.emit("loadingAllScenes", "end");
        this.trackUseTemplate();
        this.$store.commit("close_LibUseTemplateLoading");
        this.soundHandle.insertScenesArrSound(changeTime, music);
        // this.$bus.emit("timeline_update_totaltime", { data: "scenes" });

        this.$bus.emit("showScenesLoading", false);
        this.$store.commit("save_TopnavMsg", {
          isShowSavingMask: false,
          savingMaskText: "正在插入场景页..."
        });
      console.timeEnd('insertAdd');

        return {end: true};
      }
    },
    async loadTemplate (method, saveWorks) {
      if (this.locked) return;
      this.locked = true;

      const m = this[method];
      if (m) {
        const { end } = await m(saveWorks) || {};
        if (end) {
          this.locked = false;
        }
      }
    },
    loadSound(src) {
      let audioEle = document.createElement('audio');
      audioEle.src = this.$handleAssetsUrl(src);

      return new Promise(function(resolve) {
        let t = setTimeout(() => {
          resolve(0);
        }, 10000);
        audioEle.onloadedmetadata = () => {
          resolve(audioEle.duration);
          audioEle.onloadedmetadata = null;
          audioEle = null;
        }
        audioEle.onerror = () => {
          resolve(0);
        }
      })
    },
    trackUseTemplate () {
      let item = this.template || {};
      sensors.track('useTemplate', {
        author_id: this.UserMsg.id,
        author_name: this.UserMsg.nickname,
        business: '',
        content_duration: this.TOOL.getDuration() / 1000,
        // content_id: this.WorksId,
        content_name: this.WorksName,
        content_size: this.TOOL.optimized === 'Vertical' ? '9：16竖屏' : '9：16竖屏',
        create_method: '使用模板',
        price_type: ((payType) => {
          if (payType == 0) {
            return '免费'
          }
          if (payType == 1) {
            return '付费'
          }
          if (payType == 4) {
            return '会员免费'
          }
          return '全部价格'
        })(item.payType),
        price: item.price,
        purpose: '',
        source: '',
        template_id: item.id,
        template_style: '',
      });
    }
  },
  mounted() {
    //console.log('this.template', this.template);
    let _this = this;
    if (!this.isLoading) this.isLoading = true;
    else return;
    this.$http
      .get(`/api/common/material/templateData`, {
        params: { id: this.template.id },
      })
      .then(async ({ data }) => {
        if (data.code === 200) {
          let commercialResp = await this.$http.post('/api/user/material/checkCommercial', {
            dataList: JSON.stringify([{id: data.data.id}]),
            // draftId: this.WorksId
          });
          let commercial = commercialResp.data.data;
          if (commercial && commercial.length) {
            this.TOOL.isTplCommercial = 1;
          } else {
            this.TOOL.isTplCommercial = 0;
          }
        }

        _this.isLoading = true;
        if (data.code == 200) {
          let jsonObj = JSON.parse(data.data.data);
          jsonObj.scenes.forEach((scene = {}) => {
            scene.exitEffect && delete scene.exitEffect.manual;
          });
          if (jsonObj.scenes.length > 0) {
            //提前下载video blob
            let xhr = new XMLHttpRequest();
            xhr.open(
              "get",
              this.$handleAssetsUrl(this.template.videoUrl).replace(
                ".mp4",
                "nail.mp4"
              )
            );
            xhr.responseType = "blob";
            //let _this = this;
            xhr.onload = function () {
              //console.log(_this)
              _this.videoBlob = xhr.response;
              let startTime = 0;
              _this.scenes = jsonObj.scenes.map((val) => {
                let res = {
                  videoUrl: _this.template.videoUrl,
                  startTime,
                  scene: val,
                  selected: true,
                };
                startTime += val.duration;
                return res;
              });
              _this.isLoading = false;
            };
            xhr.send();
          }
          this.tempJson = jsonObj;
        }
      });
  },
};
</script>

<style lang="scss" scoped>
.templib-temp-use-root {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 8px;
  .title {
    width: 100%;
    height: 48px;
    background-color: #f0f0f8;
    box-shadow: 0 3px 7px 0 rgba(66, 79, 97, .15);
    border-radius: 8px 8px 0 0;
    .backbtn {
      position: absolute;
      top: 16px;
      left: 20px;
      color: #474261;
      font-size: 14px;
    }
    .closebtn {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 16px;
      height: 16px;
      color: #474261;
      font-size: 14px;
      background-image: url(../../../../../../static/svg/template-material-lib/common/close-1.svg);
      &:hover {
        background-image: url(../../../../../../static/svg/template-material-lib/common/close-active.svg);
      }
    }
    .tips {
      color: #474261;
      font-size: 14px;
      line-height: 48px;
    }
  }
  .chkall {
    float: left;
    margin: 25px 0 0 48px;
    color: #474261;
    font-size: 14px;
    font-stretch: normal;
    font-weight: normal;
    letter-spacing: 0;
  }
  .list {
    justify-content: center;
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    height: 85%;
  }
  .scene-list {
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow-y: auto;
    width: 100%;
    height: 80%;
    padding: 0 0 0 30px;
    margin: 40px 0 0 0;
    .scene-item {
      margin: 18px;
      &._1 {
        width: 256px;
        height: 144px;
      }
      &._2 {
        width: 160px;
        height: 286px;
      }
    }
  }

  .foot {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    width: 1226px;
    height: 56px;
    background-color: #f0f0f8;
    border-radius: 0 0 8px 8px;
    .cover {
      float: left;
      color: #5778fb;
      font-size: 12px;
      font-stretch: normal;
      font-weight: normal;
      letter-spacing: 0;
      text-decoration: underline;
    }
    .insert {
      float: left;
      width: 160px;
      height: 38px;
      margin: 9px 0 0 40px;
      color: #fff;
      font-size: 14px;
      font-stretch: normal;
      font-weight: normal;
      letter-spacing: 0;
    }
  }
  .dialog-bg {
    position: absolute;
    top: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, .4);
    .win {
      justify-content: center;
      width: 462px;
      height: 220px;
      margin: 220px 0 0 0;
      background-color: #fff;
      box-shadow: 0 0 7px 0 rgba(66, 79, 97, .15);
      border-radius: 8px;
      .close {
        float: right;
        width: 12px;
        height: 12px;
        margin: 12px 12px 0 0;
        background-image: url(../../../../../../static/svg/template-material-lib/common/close-2.svg);
      }
      .text {
        margin: 59px 47px 47px 47px;
        color: #474261;
        font-size: 14px;
      }
      .bottom {
        .yes {
          width: 120px;
          height: 40px;
        }
        .no {
          width: 120px;
          height: 40px;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/template/templateUse.vue